import {
  Award,
  Badge,
  Bitcoin,
  Book,
  Briefcase,
  Building,
  CalendarCheck,
  Code,
  Coffee,
  File as DocumentIcon,
  File,
  FileText,
  Ghost,
  Gift,
  Grid,
  Kanban,
  Layout,
  LayoutGrid,
  Monitor,
  Network,
  Users as PeopleIcon,
  SquareMousePointer,
  TrendingUp,
  Users,
  Briefcase as WorkIcon,
  MessageSquare,
} from 'lucide-react';
import { type MenuConfig } from './types';

export const MENU_MEGA_MOBILE: MenuConfig = [
  { title: 'Home', path: '/' },
  {
    title: 'Profiles',
    children: [
      {
        title: 'Profiles',
        children: [
          {
            title: 'Default',
            icon: Badge,
            path: '#',
          },
          {
            title: 'Creator',
            icon: Coffee,
            path: '#',
          },
          {
            title: 'Company',
            icon: Building,
            path: '#',
          },
          { title: 'NFT', icon: Bitcoin, path: '#' },
          {
            title: 'Blogger',
            icon: MessageSquare,
            path: '#',
          },
          { title: 'CRM', icon: Monitor, path: '#' },
          {
            title: 'Gamer',
            icon: Ghost,
            path: '#',
          },
          {
            title: 'Feeds',
            icon: Book,
            path: '#',
          },
          {
            title: 'Plain',
            icon: File,
            path: '#',
          },
          {
            title: 'Modal',
            icon: SquareMousePointer,
            path: '#',
          },
          { title: 'Freelancer', icon: Briefcase, path: '#', disabled: true },
          { title: 'Developer', icon: Code, path: '#', disabled: true },
          { title: 'Team', icon: Users, path: '#', disabled: true },
          { title: 'Events', icon: CalendarCheck, path: '#', disabled: true },
        ],
      },
      {
        title: 'Other Pages',
        children: [
          {
            title: 'Projects - 3 Cols',
            icon: Layout,
            path: '#',
          },
          {
            title: 'Projects - 2 Cols',
            icon: Grid,
            path: '#',
          },
          { title: 'Works', icon: WorkIcon, path: '#' },
          { title: 'Teams', icon: PeopleIcon, path: '#' },
          { title: 'Network', icon: Network, path: '#' },
          {
            title: 'Activity',
            icon: TrendingUp,
            path: '#',
          },
          {
            title: 'Campaigns - Card',
            icon: LayoutGrid,
            path: '#',
          },
          {
            title: 'Campaigns - List',
            icon: Kanban,
            path: '#',
          },
          { title: 'Empty', icon: FileText, path: '#' },
          { title: 'Documents', icon: DocumentIcon, path: '#', disabled: true },
          { title: 'Badges', icon: Award, path: '#', disabled: true },
          { title: 'Awards', icon: Gift, path: '#', disabled: true },
        ],
      },
    ],
  },
];

export const MENU_MEGA: MenuConfig = [
  { title: 'Home', path: '/' },
  {
    title: 'Profiles',
    children: [
      {
        title: 'Profiles',
        children: [
          {
            children: [
              {
                title: 'Default',
                icon: Badge,
                path: '#',
              },
              {
                title: 'Creator',
                icon: Coffee,
                path: '#',
              },
              {
                title: 'Company',
                icon: Building,
                path: '#',
              },
              {
                title: 'NFT',
                icon: Bitcoin,
                path: '#',
              },
              {
                title: 'Blogger',
                icon: MessageSquare,
                path: '#',
              },
              {
                title: 'CRM',
                icon: Monitor,
                path: '#',
              },
              {
                title: 'Gamer',
                icon: Ghost,
                path: '#',
              },
            ],
          },
          {
            children: [
              {
                title: 'Feeds',
                icon: Book,
                path: '#',
              },
              {
                title: 'Plain',
                icon: File,
                path: '#',
              },
              {
                title: 'Modal',
                icon: SquareMousePointer,
                path: '#',
              },
              {
                title: 'Freelancer',
                icon: Briefcase,
                path: '#',
                disabled: true,
              },
              { title: 'Developer', icon: Code, path: '#', disabled: true },
              { title: 'Team', icon: Users, path: '#', disabled: true },
              {
                title: 'Events',
                icon: CalendarCheck,
                path: '#',
                disabled: true,
              },
            ],
          },
        ],
      },
      {
        title: 'Other Pages',
        children: [
          {
            children: [
              {
                title: 'Projects - 3 Cols',
                icon: Layout,
                path: '#',
              },
              {
                title: 'Projects - 2 Cols',
                icon: Grid,
                path: '#',
              },
              { title: 'Works', icon: WorkIcon, path: '#' },
              {
                title: 'Teams',
                icon: PeopleIcon,
                path: '#',
              },
              {
                title: 'Network',
                icon: Network,
                path: '#',
              },
              {
                title: 'Activity',
                icon: TrendingUp,
                path: '#',
              },
              {
                title: 'Campaigns - Card',
                icon: LayoutGrid,
                path: '#',
              },
            ],
          },
          {
            children: [
              {
                title: 'Campaigns - List',
                icon: Kanban,
                path: '#',
              },
              { title: 'Empty', icon: FileText, path: '#' },
              {
                title: 'Documents',
                icon: DocumentIcon,
                path: '#',
                disabled: true,
              },
              { title: 'Badges', icon: Award, path: '#', disabled: true },
              { title: 'Awards', icon: Gift, path: '#', disabled: true },
            ],
          },
        ],
      },
    ],
  },
];
